import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MetaEntity, MetaService } from '../../../core/services/meta.service';

@Component({
      selector: 'app-meta-entity',
      standalone: true,
      imports: [CommonModule, FormsModule],
      templateUrl: './meta-entity.component.html'
})
export class MetaComponent implements OnInit {
      // Data State
      list: MetaEntity[] = [];
      filteredList: MetaEntity[] = [];
      searchTerm: string = '';

      // Pagination State
      pageIndex: number = 0;
      pageSize: number = 5;
      total: number = 0;

      // Form/Modal State
      isModalOpen: boolean = false;
      isEditMode: boolean = false;
      form: MetaEntity = this.resetForm();

      constructor(private service: MetaService) { }

      ngOnInit(): void {
            this.load();


      }

      load(): void {
            // We pass the search term directly to the API
            this.service.getAll(this.pageIndex, this.pageSize, this.searchTerm).subscribe({
                  next: (res: any) => {
                        this.list = res.items; // This is already the correct slice from the DB
                        this.total = res.totalCount;
                  },
                  error: (err) => console.error('Load Error', err)
            });
      }
      applyFilter(): void {
            this.pageIndex = 0; // Reset to first page on search
            this.load();
      }



      get paginatedList() {
            const start = this.pageIndex * this.pageSize;
            return this.filteredList.slice(start, start + this.pageSize);
      }

      // Action Methods
      openCreateModal() {
            this.isEditMode = false;
            this.form = this.resetForm();
            this.isModalOpen = true;
      }

      openEditModal(item: MetaEntity) {
            this.isEditMode = true;
            this.form = { ...item, dataFlow: item.dataFlow || '{}' };
            this.isModalOpen = true;
      }

      save() {
            if (!this.form.code || !this.form.name) return;

            const request = this.form.id
                  ? this.service.update(this.form.id, this.form)
                  : this.service.add(this.form);

            request.subscribe(() => {
                  this.load();
                  this.closeModal();
            });
      }

      delete(id: string) {
            if (confirm('Delete this entity?')) {
                  this.service.remove(id).subscribe(() => this.load());
            }
      }

      closeModal() {
            this.isModalOpen = false;
      }

      resetForm(): MetaEntity {
            return { code: '', name: '', description: '', viewmode: 'grid', dataFlow: '{}' };
      }

      // Pagination Helpers
      get totalPages() { return Math.ceil(this.total / this.pageSize); }

      goToPage(index: number) {
            const totalPages = Math.ceil(this.total / this.pageSize);
            if (index >= 0 && index < totalPages) {
                  this.pageIndex = index;
                  this.load();
            }
      }

      changePageSize(event: any) {
            this.pageSize = Number(event.target.value);
            this.pageIndex = 0;
            this.load();
      }
}